import { type FirstPurchaseState } from "./state";

export const initialState: FirstPurchaseState = {
  refund: null,
  benefit: { notified: false },
  isPending: false,
  isRejected: false,
  errorMessage: "",
  isConfirming: false,
  isConfirmed: false,
  confirmError: "",
};
